import React from "react"

export default function Bold (props) {
	// TODO extract in small_components to reuse ?
	return (
		<div style={{fontWeight: "bold", color:"inherit", display: "inline-block"}}>
			{props.children}
		</div>
	)
}
